import { useTranslation } from "react-i18next";

export const AdjustedGradingInformation = (props: { grade?: number}) => {
    const { t } = useTranslation("locale");
    return (
        <div>
            <p>{t("adjustedGrading.para_1")}</p>
            <div className="mt-4" />
            { props.grade ?
                <p>{t("adjustedGrading.para_2")}{props.grade}.</p>
                : <></>
            }
        </div>
    )
}